addEventListener('load', handleItemSwatchesCreation);


document.addEventListener('productGridLoad', handleItemSwatchesCreation)

document.addEventListener('productGridLoad', () => {
    // debugger;

    const observer = new IntersectionObserver(entries => {
        // Loop through the entries
        for (const entry of entries) {
        // Check if the entry is intersecting
        if (!entry.isIntersecting) {
           // If not, pause the video
           entry.target.pause();
           entry.target.classList.add("paused");
        } else {
           // If it is, play the video
           entry.target.play();
           entry.target.classList.remove("paused");
        }
        }
     });
     
     // Get all the video elements on the page
     const videos = document.querySelectorAll('video');
     
     // Observe each video
     videos.forEach(video => {
        observer.observe(video);
     });



    const loadMoreSection = document?.querySelector('.s-collection__pagination')
    const items = document.querySelectorAll('.c-product-item')
    if (items.length >= 40) {
        if (loadMoreSection) {
            loadMoreSection.style.display = 'block'
        }
    } else {
        if (loadMoreSection) {
            loadMoreSection.style.display = 'none'
        }
    }
    let loaded_prod =  document.querySelectorAll('.c-product-item').length;
    if(document.querySelector('#true-prod-count')){
        document.querySelector('#true-prod-count').innerHTML = `<strong>${loaded_prod}</strong>`;
    }
});


const loadMoreButton = document.getElementById('loadmore-btn');
// loadMoreButton.addEventListener('click', handleItemSwatches

function handleItemSwatchesCreation() {
    // debugger;
    if (window.location.pathname === "/pages/wishlist") {
        return
    }

    const productItemSwatches = document.querySelectorAll('.c-product-item__swatches__swatch > a')
    let defaultColourRule;
    // Save the colour hex for the default swatch to readd to the style attribute later
    productItemSwatches.forEach(swatch => {
        if (swatch.parentElement.getAttribute('data-handle') === swatch.closest('.c-product-item').getAttribute('data-product-handle')) {
            defaultColourRule = swatch.parentElement.getAttribute('style')
            // debugger;
        }
    })



    // Hide the swatches during processing
    productItemSwatches.forEach((swatch) => {
        // debugger;
        // swatch.setAttribute("style", "display: none;")
        // debugger;
        // swatch.parentElement.classList.add("c-product-item__swatches__swatch__hidden")


        ////////////////////////////////////////////////////////////////////
        // const swatchCSSColor = swatch.parentElement.getAttribute("style")
        // swatch.parentElement.setAttribute("style", `display: none; ${swatchCSSColor}`)
        ////////////////////////////////////////////////////////////////////
    })


    for (let i = 0; i < productItemSwatches.length; i++) {
        // debugger;
        if (productItemSwatches[i].getAttribute("data-processed") !== "true") {
        fetch(`${productItemSwatches[i].getAttribute('href')}?view=indexeddbproducts`)
        .then(response => {
            // response.json()
            if (response.ok) {
                // debugger;
                return response.json()
            } else if (response.status === 404) {
                // debugger;
                console.log("404 error")
                // response.json()
                // throw new Error('404 error')
                return Promise.reject(response)
                // productItemSwatches[i].parentElement.remove()
            }
        })
        .then(body => {
            // if (body !== undefined) {
                productTitle = body.title
                available = body.available
                productId = body.product_id
                productHandle = body.handle
                tags = body.tags


                // debugger
            productCardNode = productItemSwatches[i].closest('.c-product-item')
                if (productItemSwatches[i].closest("li").getAttribute('data-handle') === productCardNode.getAttribute('data-product-handle')) {

                    productItemSwatches[i].closest('li').classList.add('c-product-item__swatches__selected')
                    // debugger;
                    // if (initialSelectedSwatchItem !== null) {
                        productItemSwatches[i].closest("li").parentElement.prepend(productItemSwatches[i].closest('li'));
                        // debugger;
                        productItemSwatches[i].closest('li').setAttribute('data-index', 0)
                    // debugger;
                    for (let j = 0; j < tags.length; j++) {
                        // debugger;
                        if (tags[j].startsWith('Colour Swatch:') && tags[j].includes(body.handle)) {
                            // debugger;
                            let selectedSwatchColour = tags[j].split(': ')[1].split('||')[0]
                            // debugger;
                            productItemSwatches[i].closest('li').setAttribute('style', `display: flex; background-color: ${selectedSwatchColour}`)
                            // debugger;
                        }
                    }

                        // productItemSwatches[i].closest('li').setAttribute('style', 'display: flex;')
                    // }
                }
            // debugger;
            if (available === "false" && Number(productCardNode.getAttribute("data-product-id")) === body.product_id) {
                // debugger;
                productItemSwatches[i].parentElement.setAttribute("style", "display: none;")
                productItemSwatches[i].classList.add("c-product-item__swatches__swatch__hidden")
                productItemSwatches[i].parentElement.classList.remove('c-product-item__swatches__selected');
                productCardNode.remove()
            } else if (available === "false") {
                productItemSwatches[i].parentElement.remove()
            }
            // debugger
            if ($(productItemSwatches[i]).closest('ul').children('li.c-product-item__swatches__swatch').length === 1) {
                $(productItemSwatches[i]).closest('ul').remove();
                // debugger;
            }

            const swatchesLength = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch').length


            const displaySwatchesLength = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch:not([style="display: none;"])').length
            
            if (displaySwatchesLength > 4) {
                // debugger;




                // const swatchesToHide = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch').slice(4)






                // debugger;
                // const swatchesToHide = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch').not($('.c-product-item__swatches__selected')).slice(4)

                let elementsArray = []


                // if (productItemSwatches[i].closest('.c-product-item').getAttribute('data-product-id') === "6701346586756") {
                    $(productItemSwatches[i].closest('ul')).children('.c-product-item__swatches__swatch').each(function() {
                        // debugger;
                        elementsArray.push($(this))
                    })
                elementsArray.unshift(elementsArray.pop());
                if (productItemSwatches[i].closest('.c-product-item').getAttribute('data-product-handle') !== productItemSwatches[i].closest('li').getAttribute('data-handle')) {
                    const swatchesToHide = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch').slice(4)
                }
                if (productItemSwatches[i].closest('.c-product-item').getAttribute('data-product-handle') === productItemSwatches[i].closest('li').getAttribute('data-handle')) {
                    // debugger
                }
                const hexArray = []
                // const match = tags.find(tag => {
                const match = tags.map(tag => {
                    if (tag.includes("Colour Swatch")) {
                        const href = $(elementsArray[0]).children('a').attr('href')
                        const splitHref = href?.split('/')[2]
                      if (tag.includes(splitHref)) {
                        const hexValue = tag.split(":")[1].split("||")[0]
                        if (hexValue) {
                            hexArray.push(hexValue)
                            // debugger;
                        }
                      }
                    }
                });
                const elementsArrayToDom = $(elementsArray).get()
                const htmlElm = elementsArrayToDom[0][0]
                htmlElm.setAttribute('style', `background-color: ${hexArray[0]};`)
            }





            const hiddenSwatchesLength = $(productItemSwatches[i].closest('ul')).children('li.c-product-item__swatches__swatch[style="display: none;"]').length

            const prevSwatchCount = productItemSwatches[i]?.closest('.c-product-item__swatches')?.querySelector('.c-product-item__swatches__count')
            if (prevSwatchCount) {
                prevSwatchCount.remove()
            }
            if (hiddenSwatchesLength > 0) {
                // productItemSwatchesproductItemSwatches[i].closest('ul').removeChild
                const swatchCount = document.createElement('li')
                swatchCount.classList.add('c-product-item__swatches__count')
                productItemSwatches[i].closest('ul').appendChild(swatchCount)
                swatchCount.textContent = `+${hiddenSwatchesLength}`
            }
        // }
        })
        .then(() => {
            // debugger
            if (!window.location.pathname.startsWith("/cart")) {
                swatchContainer.forEach((swatch) => {
                    // swatch.setAttribute("style", "display: flex;")
                })
            }

            setTimeout(function() {
                if ($(productItemSwatches[i]).closest('ul').children('li.c-product-item__swatches__swatch').length === 1) {
                    $(productItemSwatches[i]).closest('ul').remove()
                }
                if ($(productItemSwatches[i]).closest('ul').children('li.c-product-item__swatches__swatch:not([style="display: none;"])').length < 4) {
                    $(productItemSwatches[i]).closest('li').siblings('.c-product-item__swatches__count').remove()
                    // debugger

                }


                // for (let i = 0; i < productItemSwatches.length; i++) {
                    const swatchContainer = productItemSwatches[i].closest('.c-product-item__swatches')

                    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    if ($(swatchContainer).children('.c-product-item__swatches__swatch:not([style="display: none;"])').length > 4) {
                        // debugger;
                        const swatchHideCount = $(swatchContainer).children('.c-product-item__swatches__swatch').length - 4

                        const swatchCountElement = document.createElement('li')
                        swatchCountElement.classList.add('c-product-item__swatches__count')
                        swatchCountElement.textContent = `+${swatchHideCount}`
                        
                        // $(swatchContainer).children('.c-product-item__swatches__count').text(`+${swatchHideCount}`)
                        $(swatchContainer).children('.c-product-item__swatches__swatch').slice(4).attr("style", "display: none;")
                        $(swatchContainer).append(swatchCountElement)
                    }
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

                    
                    $(swatchContainer).each(function() {
                        if ($(this).children('.c-product-item__swatches__swatch').children('a').attr('data-processed') !== "true") {
                            // debugger;
                            return false;
                        }
                        // debugger;
                        if (!window.location.pathname.startsWith("/cart")) {
                            $(this).attr("style", "display: flex;")
                        }
                    })
                    
            }, 2000)
            

        })
        .catch((err) => {
            console.log("err: ", err)
            productItemSwatches[i].parentElement.remove()
            // debugger;
        })
    }
    }

    let match;

    productItemSwatches.forEach((itemSwatch) => {
        productCardNode = itemSwatch.closest('.c-product-item')
        var productCardColour = productCardNode.getAttribute('data-product-colour')
        productCardColourAlternative = productCardNode?.getAttribute('data-product-colour-alt')

        const initialColour = productCardNode.getAttribute('data-product-colour').toLowerCase()
        const initialColourAlt = productCardNode?.getAttribute('data-product-colour-alt')?.toLowerCase()

        itemSwatch.addEventListener('click', handleSwatchClick)
    });

    const productItems = document.querySelectorAll('.c-product-item');

    productItems.forEach((productItem) => {
        const selectedSwatchItems = productItem.querySelectorAll('.c-product-item__swatches__selected')

        

        const initialSelectedSwatchItem = productItem?.querySelector('.c-product-item__swatches__selected')

        initialSelectedSwatchItem?.setAttribute('data-index', 0)
        const swatchParent = productItem.querySelector('.c-product-item__swatches')

        if (swatchParent?.length > 0 || swatchParent?.length !== undefined || swatchParent) {
            const swatchItems = swatchParent.querySelectorAll('.c-product-item__swatches__swatch')
            
                    const swatchListChildren = swatchParent.getElementsByClassName('c-product-item__swatches__swatch')
                    let swatchDifference = 0
                    swatchListChildren.forEach((swatch) => {
                        if (swatch.getAttribute('data-colour') === 'white' || 'beige' || 'cream') {
                            swatch.classList.add('c-product-item__swatches__swatch__border')
                        }
            
                        if (swatch.getAttribute('data-colour-swatch-tags') === '') {
                            swatch.classList.add('c-product-item__swatches__swatch__border')
                        }

                        if (swatch.getAttribute('data-index') > 4) {
                            swatchDifference = $(swatchParent).children('.c-product-item__swatches__swatch').length - 4
                            swatch.classList.add('c-product-item__swatches__swatch__hidden')
                        }


                    })

                    if (swatchDifference > 0 || (swatchParent.querySelectorAll(".c-product-item__swatches__swatch").length > 4)) {
                        const swatchCount = document.createElement('li')

                        if (swatchParent.querySelectorAll(".c-product-item__swatches__count").length === 0) {
                            swatchCount.classList.add('c-product-item__swatches__count')
                            swatchParent.appendChild(swatchCount)
                            let disabledSwatches = 0

                            $(swatchParent).children('li.c-product-item__swatches__swatch').each(function(index) {

                                if ($(this).is("[style~='display: none;']")) {
                                    disabledSwatches++
                                }

                            })
                            if ((swatchParent.querySelectorAll(".c-product-item__swatches__swatch").length - 4) - disabledSwatches > 0) {
                                swatchCount.textContent = `+${(swatchParent.querySelectorAll(".c-product-item__swatches__swatch").length - 4) - disabledSwatches}`
                            }
                        }
                    }
                    if ($(swatchParent).children('li').length > 5) {
                        // $(swatchParent).children('li').slice(4,5).hide();
                        
                    }
                    // const availableSwatches = $(swatchParent).children('li').attr('style').val('display: none;').length

                    let availableSwatchesCount = 0

                    swatchParent.querySelectorAll(".c-product-item__swatches__swatch").forEach((swatch) => {
                        if (swatch.style.cssText.includes('none')) {
                            availableSwatchesCount++
                        }
                    })


                    // if ($(swatchParent).children('li').find(`li:not([style="display: none;"])`).length < 2) {

                    // }

                    if (selectedSwatchItems.length > 1) {
                        selectedSwatchItems.forEach((itemSwatch) => {
                            const productCardNode = itemSwatch.closest('.c-product-item')
                            if (itemSwatch.closest("li").getAttribute('data-handle') === productCardNode.getAttribute('data-product-handle')) {
                                itemSwatch.closest('li').classList.remove('c-product-item__swatches__selected')
                            }
            
                        })
                    }
            
        }
    })

    // Show the swatches after processing
    productItemSwatches.forEach((swatch) => {
        // swatch.removeAttribute("style")
        // debugger;
        // swatch.parentElement.removeAttribute("style")


        ///////////////////////////////////////////////////////////////////////////
        if (swatch.getAttribute('data-processed') !== 'true') {
        let swatchCSSStyle = swatch.parentElement.getAttribute("style")
        swatchCSSStyle = swatchCSSStyle.replace("display: none;", "display: flex;")
        
        swatch.parentElement.setAttribute("style", swatchCSSStyle)
        // debugger;
            swatch.setAttribute("style", "display: flex;")
            swatch.setAttribute("data-processed", "true")
        }
        ///////////////////////////////////////////////////////////////////////////
    })
    const swatchContainer = document.querySelectorAll('.c-product-item__swatches')
    if (window.location.pathname.startsWith('/cart')) {
        swatchContainer.forEach((container) => {
            container.removeAttribute('style')
            container.setAttribute("style", "display: none;")
            // debugger;
        })
    }
}

// product card data
var productCardId;
var productCardNode;
var productVariantId;
var productVariantAvailable;
var productVariants;
var productCardColourAlternative;

// Title, ID, handle and prices
var productTitle;
var productId;
var productColour;
var productHandle;
var productPrice;
var productCompareAtPrice;
var datePublished;
var variants

//Image data
var productImages = [];
var productVideos = [];

// Swatch
var clickedSwatch;
var clickedSwatchColour;
var clickedSwatchColourHandle;


function handleSwatchClick(event) {

    event.preventDefault();
    productImages = [];
    clickedSwatch = event.target.closest("li")
    clickedSwatchColour = event.target.closest('li').getAttribute('data-colour');
    clickedSwatchColourHandle = event.target.closest('li').getAttribute('data-handle');


    var productCardNode = event.target.closest('.c-product-item')

    productCardId = Number(productCardNode.getAttribute('data-product-id'))
    // debugger;
    fetch(`${event.target.getAttribute('href')}.js`)
        .then(response => response.json())
        .then(body => {
            productTitle = body.title
            productId = body.id
            productAvailable = body.available
            productVariants = body.variants
            productHandle = body.handle
            productPrice = body.price / 100
            productCompareAtPrice = body.compare_at_price / 100
            datePublished = body.published_at;
            body.images.forEach((image) => {
                productImages.push(image);
            })
            productVideos = []
            body.media.forEach((video) => {
                if (video.media_type === "video"){
                    productVideos.push(video);
                }
            })
        })
        .then(() => {
            handleProductItemReplace(productCardNode)
        })
}

function handleProductItemReplace(productCardNode) {
    
    // const selectedProductItemCard = document.querySelector(`[data-product-id="${productCardId}"]`)
    const selectedProductItemCard = productCardNode

    if (selectedProductItemCard.querySelector(".ajax-submit")) {
        handleVariantReplace(selectedProductItemCard)
    }
    handleTitleReplace(selectedProductItemCard)
    handlePriceReplace(selectedProductItemCard)
    handleImageReplace(selectedProductItemCard)
    handleTagReplace(selectedProductItemCard)
    handleSwatchSelect(selectedProductItemCard)

    var compareAtPriceSpan = selectedProductItemCard.getElementsByClassName('c-product-item__price__old')
    if (compareAtPriceSpan.length !== 0) {
        compareAtPriceSpan[0].textContent = `£${productCompareAtPrice}`
        const currentPrice = selectedProductItemCard.querySelector('.c-product-item__price__current')
        currentPrice.classList.add('sale')
    }
}

function handleVariantReplace(itemCard) {

    const variantTitle = itemCard.querySelector('.add-to-bag-panel__title')
    const productViewButton = itemCard.querySelector('.add-to-bag-button')
    productViewButton.setAttribute('href', `/products/${productHandle}`)
    console.log(productHandle)
    variantTitle.innerHTML = productTitle

    const selectBox = itemCard.querySelector(".ajax-multi_select")
    var selectBoxInner = ""

    for (let i = 0; i < productVariants.length; i++) {
        let variant = productVariants[i]
        selectBoxInner += '<option value="' + variant.id + '"'
        if (variant.available == false) {
            selectBoxInner += ' disabled'
        }
        if (i == 0) {
            selectBoxInner += ' selected="selected"'
        }
        selectBoxInner += ' data-sku="' + variant.sku + '">' + variant.option2 + " - "
        if (variant.available == true) {
            selectBoxInner += 'In Stock'
        } else {
            selectBoxInner += 'Out of Stock'
        }
        selectBoxInner += '</option>'
    }

    selectBox.innerHTML = selectBoxInner
}

function handleTitleReplace(itemCard) {
    const productCardTitle = itemCard.querySelector('.c-product-item__title > a')
    productCardTitle.innerHTML = productTitle

    productCardTitle.setAttribute('href', `/products/${productHandle}`)
}

function handlePriceReplace(itemCard) {
    if (productCompareAtPrice !== null || 0) {
        var compareAtPriceSpan = document.createElement('span')
        var compareAtPriceContent = document.createTextNode(productCompareAtPrice)
        compareAtPriceSpan.appendChild(compareAtPriceContent)

        var compareAtPriceSpan = itemCard.getElementsByClassName('c-product-item__price__old')
        // let compareAtPriceSpan = itemCard.querySelector('.c-product-item__price__old')

        const currentPrice = itemCard.querySelectorAll('.c-product-item__price__current')
        if (compareAtPriceSpan.length !== 0) {
            compareAtPriceSpan.forEach(e => e.textContent = productCompareAtPrice)
            currentPrice.forEach(e => e.classList.add('sale'))
        } else {
            var priceElement = itemCard.getElementsByClassName('c-product-item__price')
            var newCompareAtSpan = document.createElement('span');
            newCompareAtSpan.setAttribute('class', 'c-product-item__price__old');
            newCompareAtSpan.textContent = `£${productCompareAtPrice}`
            priceElement.forEach(e=>e.appendChild(newCompareAtSpan))
        }
        if (productCompareAtPrice === 0) {
            compareAtPriceSpan[0].remove()
            currentPrice.forEach(e => e.classList.remove('sale'))
        }
    }
    const currentPrice = itemCard.querySelectorAll('.c-product-item__price__current')
    currentPrice.forEach(e => e.textContent = `£${productPrice}`)
    
}

function handleImageReplace(itemCard) {
    const mediaNode = itemCard.querySelector('.c-product-item__media')
    let wishlistButton = mediaNode.querySelector('button')
    wishlistButton.setAttribute('data-product-handle', productHandle)
    wishlistButton = mediaNode.querySelector('button')

    const imageAnchor = mediaNode.querySelector('a')
    imageAnchor.setAttribute('href', `/products/${productHandle}`)
    imageAnchor.setAttribute('title', productTitle)
    const pictureNodes = mediaNode.querySelectorAll('img, video')
    // debugger;
    pictureNodes.forEach((picture, outerIndex) => {
        let srcSet = picture.getAttribute('srcset')
        if (srcSet === null) {
            srcSet = picture.querySelector('source')?.getAttribute('src')
        }
        let srcSetArr = null;
        if (srcSet) {
            srcSetArr = srcSet.split(",")
            srcSetArr = srcSetArr.map((src) => src.trim())
        }
        
        const newSrcSetArr = []
        if (srcSetArr !== null) {
            // debugger
            srcSetArr.forEach((src) => {
                // debugger;
                if (src.split(" ")[1]) {
                    const width = src.split(" ")[1].match(/[a-zA-Z]+|[0-9]+/g)[0]
                    const newSrc = `${productImages[outerIndex]}&width=${width} ${width}w`
                    newSrcSetArr.push(newSrc.trim())
                    // debugger
                } else {
                    const newSrc = `${productImages[outerIndex]}&width=300 300w`
                    newSrcSetArr.push(newSrc.trim())
                    // debugger
                }    
            })
        }

        const newSrcSetStr = newSrcSetArr.join(",")
        // picture.setAttribute('srcset', newSrcSetStr)
        // debugger
        if (picture.srcset !== undefined && productVideos.length === 0) {
            picture.srcset = newSrcSetStr
        } else {
            // const newPicture = document.createElement('img')
            // newPicture.setAttribute('srcset', newSrcSetStr)
            // picture.parentNode.replaceChild(newPicture, picture)

            if (productVideos.length > 0 && outerIndex === 0) {
                const frontVideo = document.createElement("video");
                frontVideo.style.visibility = "hidden"
                frontVideo.setAttribute('loop', "")

                frontVideo.setAttribute('autoplay', "")
                frontVideo.setAttribute('playsinline', "")

                frontVideo.muted = "muted"

                const frontVideoSource = document.createElement("source");

                productVideos[0].sources.forEach((video) => {
                    if (video.format === "mp4" && video.height >= picture.height) {
                        frontVideo.style.objectFit = 'fill'
                        frontVideo.style.width = '100%';
                        frontVideo.style.height = '100%';
                        frontVideo.setAttribute("src", video.url);
                        frontVideo.play();
                        frontVideo.style.visibility = "visible"
                    }
                })

                frontVideo.appendChild(frontVideoSource);
                picture.parentNode.appendChild(frontVideo);
                picture.remove()
            } else if (productVideos.length === 0) {
                debugger
                const frontPicture = document.createElement("img");
                frontPicture.classList.add("js-lazy-load");
                frontPicture.classList.add("spf-product-card__image");
                frontPicture.classList.add("spf-product-card__image-main");
                frontPicture.setAttribute("style", "padding-top: 0px; position: absolute;")
                frontPicture.setAttribute("width", "1200");
                frontPicture.setAttribute("loading", "lazy");
                frontPicture.setAttribute("data-loaded", "true");
                frontPicture.setAttribute("sizes", "(min-width: 3000px) calc(25vw),(min-width: 1500px) calc(25vw),(min-width: 1024px) calc(25vw),(min-width: 1000px) calc(33vw),(min-width: 768px) calc(33vw),(min-width: 750px) calc(50vw),(min-width: 535px) calc(50vw),(min-width: 330px) calc(50vw),(min-width: 165px) calc(50vw)");

                // frontPicture.setAttribute("srcset", `${product.images[0]}&width=82 82w, ${product.images[0]}&width=165 165w, ${product.images[0]}&width=267 267w, ${product.images[0]}&width=375 375w, ${product.images[0]}&width=1000 1000w, ${product.images[0]}&width=1200 1200w`);

                frontPicture.setAttribute("srcset", `${productImages[0]}&width=82 82w, ${productImages[0]}&width=165 165w, ${productImages[0]}&width=267 267w, ${productImages[0]}&width=375 375w, ${productImages[0]}&width=1000 1000w, ${productImages[0]}&width=1200 1200w`);

                // frontPicture.setAttribute("data-iesrc", product.image);
                // frontPicture.setAttribute("data-alt", product.title);
                picture.parentNode.appendChild(frontPicture);
                
                const rearPicture = document.createElement("img");
                rearPicture.classList.add("js-lazy-load");
                rearPicture.classList.add("spf-product-card__image");
                rearPicture.classList.add("spf-product-card__image-secondary");
                rearPicture.setAttribute("style", "padding-top: 0px; position: absolute;")
                rearPicture.setAttribute("width", "1200");
                rearPicture.setAttribute("loading", "lazy");
                rearPicture.setAttribute("data-loaded", "true");
                rearPicture.setAttribute("sizes", "(min-width: 3000px) calc(25vw),(min-width: 1500px) calc(25vw),(min-width: 1024px) calc(25vw),(min-width: 1000px) calc(33vw),(min-width: 768px) calc(33vw),(min-width: 750px) calc(50vw),(min-width: 535px) calc(50vw),(min-width: 330px) calc(50vw),(min-width: 165px) calc(50vw)");
                // rearPicture.setAttribute("srcset", `${product.images[1]}&width=82 82w, ${product.images[1]}&width=165 165w, ${product.images[1]}&width=267 267w, ${product.images[1]}&width=375 375w, ${product.images[1]}&width=1000 1000w, ${product.images[1]}&width=1200 1200w`);

                rearPicture.setAttribute("srcset", `${productImages[1]}&width=82 82w, ${productImages[1]}&width=165 165w, ${productImages[1]}&width=267 267w, ${productImages[1]}&width=375 375w, ${productImages[1]}&width=1000 1000w, ${productImages[1]}&width=1200 1200w`);

                // rearPicture.setAttribute("data-iesrc", product.image);
                // rearPicture.setAttribute("data-alt", product.title);
                picture.parentNode.appendChild(rearPicture);
                picture.remove();
            }
            if (productVideos.length > 0 && outerIndex > 0) {
                picture.remove()
            }

        }
        // debugger;
        // picture.setAttribute('srcset', `${productImages[outerIndex]}





        // const finalImgTags = picture.querySelectorAll('img');
        // finalImgTags[0].setAttribute('src', `${productImages[outerIndex]}&width=3024`)
        // finalImgTags[1].setAttribute('alt', productTitle)
        
        // const finnalImgTag = document.createElement('img')
        // finnalImgTag.setAttribute('src', `${productImages[outerIndex]}&width=3024`)
    })
    // pictureNodes.appendChild(finnalImgTag)
}

function handleTagReplace (itemCard) {
    const tagsElement = itemCard.querySelector('.tags')   
    const limit = 3600 * 24 * 7;
    const date_published = Date.parse(datePublished)
    const date_difference = Date.now() - date_published

    if (!productCompareAtPrice) {
        tagsElement.innerHTML = ""
    }
    if (date_difference < limit) {
        tagsElement.childNodes[0].setAttribute('class', 'new')
        tagsElement.childNodes[0].innerText = "New"
    }

    if (productCompareAtPrice > productPrice) {
        tagsElement.innerHTML = '<span class="sale"></span>'
        // tagsElement.childNodes[0].setAttribute('class', 'sale')
        tagsElement.childNodes[0].innerText = "Sale"
    }

    const variantNotAvailable = (variant) => {
        return variant.available === false
    }

    const noVariantsAvailable = productVariants.every(variantNotAvailable)

    if (noVariantsAvailable) {
        if (tagsElement.childNodes[0]) {
        tagsElement?.childNodes[0].setAttribute('class', 'sold-out')
        tagsElement.childNodes[0].innerText = "Sold out"
        }
    }
    if (productAvailable === false) {
        // debugger;
        if (tagsElement) {
            // debugger;
            tagsElement.innerHTML = '<span class="sold-out"></span>'
            tagsElement?.childNodes[0].setAttribute('class', 'sold-out')
            tagsElement.childNodes[0].innerText = "Sold out"
        }
    }
}

function handleSwatchSelect(itemCard) {
    productColour = itemCard.getAttribute('data-product-colour').toLowerCase();
    const productColourAlt = itemCard.getAttribute('data-product-colour-alt')?.toLowerCase();


    if ((clickedSwatchColour !== productColour) || (clickedSwatchColour !== productColourAlt)) {
        const cardItemSwatches = itemCard.querySelectorAll('.c-product-item__swatches__swatch')

        cardItemSwatches.forEach((itemSwatch) => {
            itemSwatch.classList.remove("c-product-item__swatches__selected")
        });
        clickedSwatch.classList.add("c-product-item__swatches__selected")

        //SET ATTRIBUTES BELOW
        itemCard.setAttribute('data-product-colour', clickedSwatchColour)
    }
}